var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg"},[_c('div',{style:({zIndex: _vm.zIndex}),attrs:{"id":"scattered-images-canvas"}}),_c('img',{staticClass:"image",attrs:{"src":"#","hidden":"hidden","id":"scattered-image-template"}})])}
var staticRenderFns = []

export { render, staticRenderFns }